import { styled } from "@mui/material"

const chipStyle = {
  display: "flex",
  padding: "4px 8px",
  gap: 4,
  borderRadius: 99,
  border: "1px solid #ddd",
  alignItems: "center",
  "&.ChipButton-blend": {
    background: "white",
    border: "1px solid #eee",
    "&:hover": {
      border: "1px solid #ddd",
    },
  },
}

export const ChipButton = styled("button")(chipStyle)

type CheckboxChipProps = {
  checked: boolean
  children: React.ReactNode
  variant?: "blend"
  onClick?: () => void
}

export function CheckboxChip({
  checked,
  children,
  variant,
  onClick,
}: CheckboxChipProps) {
  return (
    <ChipButton
      className={variant === "blend" ? "ChipButton-blend" : undefined}
      onClick={onClick}
    >
      <span style={{ display: "inline-block", width: 20 }}>
        {checked ? "✔" : ""}
      </span>
      {children}
    </ChipButton>
  )
}
